module.exports = __webpack_public_path__ + "static/C2026_ICLR_abs-cf4b19195622312a3cba784503fcd537.png";